var _a, _b;
import { __decorate, __metadata, __param } from "tslib";
// @ts-nocheck todo
import _ from 'lodash';
import { getAllWorkspace, getSearchFolderResult } from '@cores/apis/workspace_api/workspace';
import { listToTree, treeToListByDFS } from '@cores/utils/listTree';
import { inject, injectable } from '@/inversify.config';
import { UserService } from '@/domains/user/services/user-service.interface';
import { SpaceService } from '@/domains/detail/space/types/space-service.interface';
export const FolderSelectorServiceSymbol = Symbol.for('FolderSelectorService');
let FolderSelectorService = class FolderSelectorService {
    constructor(userService, spaceService) {
        this.userService = userService;
        this.spaceService = spaceService;
        this.vm = '';
        this.mode = 'multiple';
        this.promiseUID = _.uniqueId();
        this.folderLoopProtectionFlag = 10;
        this.loading = false;
        this.currentWorkspace = this.spaceService.spaceInfo;
        this.selectedWorkspace = null;
        this.selectedFolder = [];
        this.folderSearchKeywords = '';
        this.lastFolderSearchKeywords = '';
        this.response = null;
        this.workspaceGroupList = [];
        this.folderNameHighlightClassName = 'folder-name-heighlight-key';
        this.selectedList = [];
        this.initWorkspaceScroll = false; // 是否进行过初始滚动;
        this.initFolderScroll = false;
    }
    get selfWorkspaceList() {
        return _.get(this.workspaceGroupList, '[0].workspaces', []);
    }
    get workspaceList() {
        const workspaceList = [];
        _.forEach(this.workspaceGroupList, ({ workspaces }) => {
            workspaceList.push(...workspaces);
        });
        return workspaceList;
    }
    get isSingleMode() {
        return this.mode === 'single';
    }
    get isOverMergeLimit() {
        return this.selectedList.length + 1 > this.userService.userCapacity.max_merge_folder;
    }
    init() {
        this.initFolderSelector();
    }
    initFolderSelector() {
        this.fetchWorkspaces();
    }
    getWorkspaceGroupType({ is_public_space, is_shared_space }) {
        if (is_public_space) {
            return 'public';
        }
        if (is_shared_space) {
            return 'shared';
        }
        return 'self';
    }
    fetchWorkspaces() {
        const { folderSearchKeywords } = this;
        const searchParams = {
            need_share_space: true,
            need_public_space: true,
            folder_search_name: folderSearchKeywords,
            data_type: this.type,
        };
        this.loading = true;
        this.workspaceGroupList = [];
        this.latestWorkspaceId = null;
        this.latestFolderId = null;
        this.selectWorkspace(null).then(() => {
            this.selectFolder(null);
        }).catch(() => { });
        this.promiseUID = _.uniqueId();
        const { promiseUID } = this;
        this.lastFolderSearchKeywords = folderSearchKeywords;
        return getAllWorkspace(searchParams)
            .then((response) => {
            if (this.promiseUID !== promiseUID)
                return;
            this.response = _.cloneDeep(response);
            const spaces = _.map([
                ..._.sortBy(_.get(response, 'self') || [], ({ update_ts }) => -new Date(update_ts)),
                ..._.sortBy(_.get(response, 'shared') || [], ({ update_ts }) => -new Date(update_ts)),
                ..._.sortBy(_.get(response, 'public') || [], ({ update_ts }) => -new Date(update_ts)),
            ], (workspace) => workspace);
            const groups = _.groupBy(spaces, (space) => this.getWorkspaceGroupType(space));
            this.workspaceGroupList = [
                { type: 'self', expand: false, workspaces: groups.self || [] },
                { type: 'shared', expand: false, workspaces: groups.shared || [] },
                { type: 'public', expand: false, workspaces: groups.public || [] },
            ];
            if (!spaces || !spaces.length) {
                this.loading = false;
                return;
            }
            let defaultWorkspace = _.find(this.workspaceList, { space_id: this.currentWorkspace.space_id });
            if (!folderSearchKeywords) {
                const { folder_id: latestFolderId, space_id: latestWorkspaceId, } = _.last(this.selectedList) || {};
                if (latestWorkspaceId && latestFolderId) {
                    this.latestWorkspaceId = latestWorkspaceId;
                    this.latestFolderId = latestFolderId;
                    const latestWorkspace = _.find(spaces, { space_id: latestWorkspaceId });
                    if (latestWorkspace) {
                        defaultWorkspace = latestWorkspace;
                    }
                }
            }
            else {
                defaultWorkspace = spaces[0];
            }
            this.selectWorkspace(defaultWorkspace).then(() => {
                const { latestFolderId, selectedWorkspace } = this;
                let defaultFolder = _.get(selectedWorkspace, 'folderTreeData[0]');
                if (!folderSearchKeywords) {
                    defaultFolder = _.find(selectedWorkspace.folderTreeList, { folder_id: latestFolderId }) || defaultFolder;
                }
                this.selectFolder(defaultFolder);
                if (selectedWorkspace && (defaultFolder !== selectedWorkspace.folderTreeData[0])) {
                    this.expandFolderParent({
                        workspace: selectedWorkspace,
                        folder: defaultFolder,
                    });
                }
            }).catch(() => { });
            // 如果是搜索, 则默认展开全部工作空间，否则只展开默认选中工作空间的类型
            const workspaceGroupType = this.getWorkspaceGroupType(defaultWorkspace || {});
            _.forEach(this.workspaceGroupList, (group) => {
                if (folderSearchKeywords) {
                    group.expand = true;
                }
                if (group.type === workspaceGroupType) {
                    group.expand = true;
                }
            });
            this.loading = false;
        })
            .catch(() => {
            this.loading = false;
        });
    }
    async selectWorkspace(workspace) {
        this.initFolderScroll = false;
        this.selectedWorkspace = workspace;
        // 如果选中了某个工作空间，则其所在的组自动展开
        if (workspace) {
            const group = _.find(this.workspaceGroupList, { type: this.getWorkspaceGroupType(workspace) });
            if (!group.expand) {
                group.expand = true;
            }
            // 判断是否需要远程加载
            if (!workspace.folder_info_simples && !workspace.isLoading) {
                await this.fetchFolders({ workspace, folder_search_name: this.folderSearchKeywords });
                if (this.selectedWorkspace !== workspace) {
                    throw new Error();
                }
            }
        }
    }
    setDefaultOption(folder) {
        if (_.get(folder, 'folder_id', '') === _.get(this.selectedList, '[0].folder_id')) {
            return;
        }
        this.selectedList = folder ? [folder] : [];
        const { space_id = this.currentWorkspace.space_id, folder_id = this.currentWorkspace.folder_id } = folder || {};
        const defaultWorkspace = _.find(this.workspaceList, { space_id });
        this.selectWorkspace(defaultWorkspace).then(() => {
            const { selectedWorkspace } = this;
            let defaultFolder = _.get(selectedWorkspace, 'folderTreeData[0]');
            defaultFolder = _.find(selectedWorkspace.folderTreeList, { folder_id }) || defaultFolder;
            this.selectFolder(defaultFolder);
            if (selectedWorkspace && (defaultFolder !== selectedWorkspace.folderTreeData[0])) {
                this.expandFolderParent({
                    workspace: selectedWorkspace,
                    folder: defaultFolder,
                });
            }
        }).catch(() => { });
    }
    selectFolder(folder) {
        this.selectedFolder = folder;
    }
    setSelectedFolderList(folder) {
        if (this.isSingleMode) {
            if (folder && folder.is_selected) {
                this.selectedList = [folder];
            }
            else {
                this.selectedList = [];
            }
            return;
        }
        const index = _.findIndex(this.selectedList, { folder_id: folder.folder_id });
        if (index < 0 && folder.is_selected) {
            if (this.isOverMergeLimit) {
                return true;
            }
            this.selectedList.push(folder);
        }
        else if (index > -1) {
            this.selectedList.splice(index, 1);
        }
    }
    expandFolderParent({ workspace, folder }) {
        const folders = treeToListByDFS(workspace.folderTreeData) || [];
        let folder$ = folder;
        while (folder$) {
            folder$ = _.find(folders, { folder_id: folder$.parent_id });
            if (folder$) {
                this.vm.$set(folder$, 'expand', true);
            }
        }
    }
    fetchFolders({ workspace, folder_search_name }) {
        const { space_id } = workspace;
        this.vm.$set(workspace, 'isLoading', true);
        return getSearchFolderResult({ space_id, folder_search_name }).then((response) => {
            const folders = _.uniqBy(response, 'folder_id');
            // 在QA环境发现有一个workspace里folder列表会返回好几个相同的key的folder，应该是测试数据,做一下兜底;
            if (folders.length !== response.length) {
                // eslint-disable-next-line no-console
                console.warn('[Folder Selector] 存在相同key的folder', space_id, [folders.length, response.length]);
            }
            if (folder_search_name) {
                _.forEach(folders, (folder) => {
                    folder.expand = true;
                });
            }
            this.vm.$set(workspace, 'folder_info_simples', folders);
            this.vm.$set(workspace, 'folderTreeData', listToTree(workspace.folder_info_simples, '-root', 'folder_id', 'parent_id'));
            this.vm.$set(workspace, 'folderTreeList', treeToListByDFS(workspace.folderTreeData));
            this.vm.$set(workspace, 'isLoading', false);
            return folders;
        }).catch(() => {
            this.vm.$set(workspace, 'isLoading', false);
            this.vm.$set(workspace, 'folder_info_simples', []);
            this.vm.$set(workspace, 'folderTreeData', []);
            this.vm.$set(workspace, 'folderTreeList', []);
        });
    }
    getWorkspaceIcon(workspace) {
        const { is_shared_space, is_public_space } = workspace || {};
        if (is_shared_space) {
            return 'SolidSpaceShared';
        }
        if (is_public_space) {
            return 'SolidCompany';
        }
        return 'Solid3D';
    }
    getFolderIcon({ folder }) {
        if (folder.folder_auto_update) {
            return 'SolidAutoFolder';
        }
        return 'SolidFolderClosed2';
    }
    toggleFolderExpand({ folder }) {
        const expand = !folder.expand;
        this.vm.$set(folder, 'expand', expand);
    }
    renderFolderName({ folder }) {
        const name = folder.folder_name;
        const { lastFolderSearchKeywords, folderNameHighlightClassName } = this;
        if (!lastFolderSearchKeywords || !name)
            return name;
        // eslint-disable-next-line no-useless-escape
        const filterWords = lastFolderSearchKeywords.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        return name.replace(new RegExp(filterWords, 'ig'), (i) => `<span class="${folderNameHighlightClassName}">${i}</span>`);
    }
    isWorkspaceSelected(workspace) {
        const index = _.findIndex(this.selectedList, { space_id: workspace.space_id });
        return index > -1;
    }
    isFolderSelected(folder) {
        if (this.isSingleMode) {
            return folder.folder_id === _.get(this, 'selectedList.[0].folder_id', '');
        }
        const index = _.findIndex(this.selectedList, { folder_id: folder.folder_id });
        return index > -1;
    }
    clearSelectedList() {
        this.selectedList = [];
    }
    scrollIntoViewIfNeeded(el) {
        if (!el)
            return false;
        if (el.scrollIntoViewIfNeeded) {
            el.scrollIntoViewIfNeeded();
            return true;
        }
        el.scrollIntoView();
        return true;
    }
};
FolderSelectorService = __decorate([
    injectable(),
    __param(0, inject(UserService)),
    __param(1, inject(SpaceService)),
    __metadata("design:paramtypes", [typeof (_a = typeof UserService !== "undefined" && UserService) === "function" ? _a : Object, typeof (_b = typeof SpaceService !== "undefined" && SpaceService) === "function" ? _b : Object])
], FolderSelectorService);
export { FolderSelectorService };
export default FolderSelectorService;
